import React, { useEffect, useState, useMemo } from "react";
import { MapContainer, TileLayer, Polygon, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "./ClockInMap.css"; // Import CSS file

function ClockInMap({ userLocation, onLocationCheck }) {
  const customMarker = L.icon({
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
    shadowSize: [41, 41],
  });

  //My house location
  // const boxCoordinates = useMemo(() => [
  //     [3.210569, 101.608969], // Top-left
  //     [3.210899, 101.609659], // Top-right
  //     [3.210421, 101.609885], // Bottom-right
  //     [3.210087, 101.609178], // Bottom-left
  // ], []);

  //Penang Location
  const boxCoordinates = useMemo(() => [
      [5.295965, 100.266285], // Top-left
      [5.294435, 100.268565], // Top-right
      [5.290561, 100.264944], // Bottom-right
      [5.293285, 100.263104], // Bottom-left
  ], []);

  //Terengganu Location
  // const boxCoordinates = useMemo(() => [
  //   [5.380467, 103.105820], // Top-left
  //   [5.378836, 103.107436], // Top-right
  //   [5.376653, 103.105365], // Bottom-right
  //   [5.378217, 103.103582], // Bottom-left
  // ], []);

  const [isInside, setIsInside] = useState(false);

  useEffect(() => {
    if (userLocation) {
      const poly = L.polygon(boxCoordinates);
      const point = L.latLng([userLocation[0], userLocation[1]]);
      const inside = poly.getBounds().contains(point);
      setIsInside(inside);
      onLocationCheck(inside);
    }
  }, [userLocation, onLocationCheck, boxCoordinates]);

  function CenterMapButton({ target, label, position }) {
    const map = useMap();

    const handleCenterMap = () => {
      if (Array.isArray(target)) {
        map.setView(target, map.getZoom());
      } else if (target instanceof L.LatLngBounds) {
        map.fitBounds(target);
      }
    };

    return (
      <button
        onClick={handleCenterMap}
        className="center-map-button"
        style={{ right: position }}
      >
        {label}
      </button>
    );
  }

  return (
    <div className="clock-in-map">
      <MapContainer center={userLocation} zoom={16} className="map-container">
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://carto.com/">Carto</a>'
        />

        <Polygon positions={boxCoordinates} color="blue" />

        {userLocation && (
          <Marker position={userLocation} icon={customMarker}>
            <Popup>
              📍 You are here. <br />
              {isInside ? "✅ Inside Clock-In Area" : "❌ Outside Clock-In Area"}
            </Popup>
          </Marker>
        )}

        <div className="center-map-buttons">
          {userLocation && (
            <CenterMapButton
              target={userLocation}
              label="Center on My Location"
            />
          )}

          <CenterMapButton
            target={L.polygon(boxCoordinates).getBounds()}
            label="Center on Clock-In Area"
            position="30%"
          />
        </div>
      </MapContainer>
    </div>
  );
}

export default ClockInMap;